import { render, staticRenderFns } from "./creatInfaceDialog.vue?vue&type=template&id=66925c50&scoped=true&"
import script from "./creatInfaceDialog.vue?vue&type=script&lang=js&"
export * from "./creatInfaceDialog.vue?vue&type=script&lang=js&"
import style0 from "./creatInfaceDialog.vue?vue&type=style&index=0&id=66925c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66925c50",
  null
  
)

export default component.exports